module.exports = __webpack_public_path__ + "media/images/icon__infoBox@3x-5d0f7f1dd253fbe62d7103b0cf30b9dc.png";